const translations = {
  groups: 'Admission Tests',
  myGroups: 'MY TESTS',
};

export default translations;
